import { render, staticRenderFns } from "./VideoArchiveLink.vue?vue&type=template&id=8f885336"
import script from "./VideoArchiveLink.vue?vue&type=script&lang=js"
export * from "./VideoArchiveLink.vue?vue&type=script&lang=js"
import style0 from "./VideoArchiveLink.vue?vue&type=style&index=0&id=8f885336&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports